/* eslint-disable prefer-named-capture-group */
import { empty } from '../helpers/helpers'
import { STATUS_ASSINATURA, MSG_STATUS_ASSINATURA, PLANOS } from '../../constants'
import { REFERENCE_PRONOUNS } from '../../containers/Perfil/constantsPerfil'


/* eslint-disable no-param-reassign */
export function formatCEP( cep ) {
  if ( cep ) {
    return `${cep.slice( 0, 5 )}${cep.length > 5 ? '-' : ''}${cep.slice( 5, 8 )}`
  }
}

export const formatValor = ( { valor } ) => {
  if ( valor ) {
    valor = parseFloat( valor, 10 )
    if ( typeof Intl !== 'undefined' && Intl.NumberFormat ) {
      return new Intl.NumberFormat( 'pt-BR', {
        'currency': 'BRL',
        'minimumFractionDigits': 2,
        'style': 'currency'
      } ).format( valor )
    } else {
      valor = valor.toFixed( 2 ).toString()
    }
    return `R$${valor.replace( '.', ',' )}`
  } else {
    if ( valor === 0 ) {
      return `R$ 0,00`
    }
    return ''
  }
}

export const formatMesPorExtenso = ( mes ) => {
  if ( !mes ) {
    return null
  }
  const mesPorExtenso = new Intl.DateTimeFormat( 'pt-BR', { 'month': 'long' } )
    .format( new Date( null, mes - 1 ) )
  return mesPorExtenso[ 0 ].toUpperCase() + mesPorExtenso.substr( 1 )
}

export const formartNumeroCartao = numero => {
  if ( empty( numero ) ) {
    return ''
  } else if ( numero.length <= 4 ) {
    return numero
  } else if ( numero.length <= 8 ) {
    return `${numero.substring( 0, 4 )} ${numero.substring( 4 )}`
  } else if ( numero.length <= 12 ) {
    return `${numero.substring( 0, 4 )} ${numero.substring( 4, 8 )} ${numero.substring( 8 )}`
  }

  const valor = `${numero.substring( 0, 4 )} ${numero.substring( 4, 8 )} ${numero.substring( 8, 12 )} ${numero.substring( 12 )}`
  return valor.substring( 0, 19 )
}


export const formatData = data => {
  if ( empty( data ) ) {
    return ''
  } else if ( data.length <= 2 ) {
    return data
  }

  const valor = `${data.substring( 0, 2 )}/${data.substring( 2 )}`

  return valor.substring( 0, 5 )
}

export const formatNomeCartao = value => {
  return value.toUpperCase().replace( /[\d~`!@#$*%^ˆ&()_={}[\]:;,.<>+/?-]+/ug, '' )
}

export const formatCVV = value => {
  return value.substring( 0, 4 )
}

export const normalizeNumberString = ( str ) => {
  if ( !str ) {
    return ''
  } else {
    return str.replace( /\D/gu, '' )
  }
}

export const normalizeString = ( str ) => {
  if ( !str ) {
    return ''
  }
  return str.toString().toLowerCase()
    .normalize( 'NFD' )
    .replace( /[\u0300-\u036f]/gu, '' )
}

export const formatCPF = cpf => {
  let valor = null
  if ( cpf.length <= 3 ) {
    valor = cpf
  } else if ( cpf.length <= 6 ) {
    valor = `${cpf.substring( 0, 3 )}.${cpf.substring( 3 )}`
  } else if ( cpf.length <= 9 ) {
    valor = `${cpf.substring( 0, 3 )}.${cpf.substring( 3, 6 )}.${cpf.substring( 6 )}`
  } else {
    valor = `${cpf.substring( 0, 3 )}.${cpf.substring( 3, 6 )}.${cpf.substring( 6, 9 )}-${cpf.substring( 9 )}`
  }

  return valor.substring( 0, 14 )
}

export const formatTelefone = telefone => {
  let valor = null

  if ( !telefone ) {
    return ''
  }

  const dotPos = telefone.length > 10 ? '7' : '6'
  if ( telefone.length <= 2 ) {
    valor = `(${telefone}`
  } else if ( telefone.length <= dotPos ) {
    valor = `(${telefone.substring( 0, 2 )}) ${telefone.substring( 2 )}`
  } else {
    valor = `(${telefone.substring( 0, 2 )}) ${telefone.substring( 2, dotPos )}-${telefone.substring( dotPos )}`
  }

  return valor.substring( 0, 15 )
}

export const transformarSnakeEmCamel = str => str.replace(
  /([-_][a-z])/gu,
  group => group.toUpperCase()
    .replace( '-', '' )
    .replace( '_', '' )
)

export const formatDataNascimento = ( data, antigoDivisor, novoDivisor ) => {
  let valor = null

  if ( !data ) {
    return ''
  }

  if ( data.indexOf( antigoDivisor ) !== -1 ) {
    const nascimento = data.split( antigoDivisor )
    const [ ano, mes, dia ] = nascimento
    valor = `${dia}${novoDivisor}${mes}${novoDivisor}${ano}`
  } else {
    valor = `${data.substring( 0, 2 )}${data.length > 2 ? novoDivisor : ''}${data.substring( 2, 4 )}${data.length > 4 ? novoDivisor : ''}${data.substring( 4, 8 )}`
  }

  return valor.substring( 0, 10 )
}

export const formatReferencePronoun = ( data ) => {
  if ( !data ) {
    return ''
  }

  const pronoun = REFERENCE_PRONOUNS.find( item => item.value === data )
  if ( pronoun ) {
    return pronoun.visualizacao
  }
  return ''
}

export const transformarRespostaEmCamel = item => {
  if ( item instanceof Array ) {
    return item.map( valor => {
      if ( typeof valor === 'object' ) {
        // eslint-disable-next-line no-param-reassign
        valor = transformarRespostaEmCamel( valor )
      }
      return valor
    } )
  }

  const newO = {}
  let newKey
  let value
  for ( const origKey in item ) {
    if ( Object.prototype.hasOwnProperty.call( item, origKey ) ) {
      newKey = transformarSnakeEmCamel( origKey )
      value = item[ origKey ]
      if (
        value instanceof Array || ( value !== null && value.constructor === Object )
      ) {
        value = transformarRespostaEmCamel( value )
      }
      newO[ newKey ] = value
    }
  }
  return newO
}

export const getNumeroParcelasPlano = ( tipoPlano ) => {
  const plano = PLANOS.find( item => item.visualizacao.toLowerCase() === tipoPlano.toLowerCase() )
  return plano.parcelas
}

export const calcularParcelas = ( tipoPlano, total ) => {
  return Number( total ) / getNumeroParcelasPlano( tipoPlano )
}

export const formataDescricaoStatus = ( status ) => {
  const statusLowerCase = String( status ).toLowerCase()

  switch ( statusLowerCase ) {
    case STATUS_ASSINATURA.ATIVO:
      return MSG_STATUS_ASSINATURA.ATIVO
    case STATUS_ASSINATURA.SUSPENSO:
      return MSG_STATUS_ASSINATURA.SUSPENSO
    case STATUS_ASSINATURA.CANCELADO:
      return MSG_STATUS_ASSINATURA.CANCELADO
    case STATUS_ASSINATURA.SOLICITOU_CANCELAMENTO:
      return MSG_STATUS_ASSINATURA.SOLICITOU_CANCELAMENTO
    default:
      return ''
  }
}
